import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import Logger from '../../../lib/analytics/logger';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import { validateJson } from '../../../utils/jsonschema/validator';
import { getGameRoomResponseHandler, updateGameRooms } from './utils';
import ERROR_CODE from '../../../utils/errorCodes';
export var getGameRoomsQuery = {
  query: function query() {
    return {
      url: Endpoints.GET_GAME_ROOMS
    };
  },
  transformResponse: function transformResponse(response) {
    var _response$;

    if (!(response === null || response === void 0 ? void 0 : response[0]) || (response === null || response === void 0 ? void 0 : (_response$ = response[0]) === null || _response$ === void 0 ? void 0 : _response$.success) === false) return response;
    if (validateJson(Endpoints.GET_GAME_ROOMS, response)) return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
      var dispatch, queryFulfilled, res, responseData, eventPayload, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              res = _context.sent;
              responseData = res === null || res === void 0 ? void 0 : res.data[0];

              if (!(!responseData || (responseData === null || responseData === void 0 ? void 0 : responseData.success) === false)) {
                _context.next = 10;
                break;
              }

              eventPayload = {
                description: "Failed to load game room, ".concat(responseData === null || responseData === void 0 ? void 0 : responseData.error),
                code: 32
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw Error("[Get-Game-Rooms-response] ".concat(responseData === null || responseData === void 0 ? void 0 : responseData.error));

            case 10:
              response = getGameRoomResponseHandler(responseData);
              response && updateGameRooms(response, dispatch);
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
                code: ERROR_CODE.LOBBY_OVERLAY_FETCH_GAME_ROOMS_FAIL
              });
              handleQueryLoggerEvents(_context.t0);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};